import { createContext, useContext, useEffect, useState } from "react";
import { api, getToken, setToken } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);
  useEffect(() => {
    if (!getToken()) return setUser(null);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { setToken(null); setUser(null); });
  }, []);
  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setToken(r.data.token);
    setUser(r.data.user);
  };
  const logout = () => { setToken(null); setUser(null); };
  const can = (m) => !!user?.modules?.includes(m);
  return <AuthCtx.Provider value={{ user, login, logout, can }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
